<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-input
      :field="`conditionsRequirements.${timeOfDayStartField}`"
      class="col-4"
      :label="$_.startCase(timeOfDayStartField)"
      value-type="String"
      :rules="[
        val => val !== null || 'Field is required',
        val => !conditional.conditionsRequirements[timeOfDayEndField] || conditional.conditionsRequirements[timeOfDayStartField] <= conditional.conditionsRequirements[timeOfDayEndField] || 'Time cannot start after end time',
      ]"
      @click="showStartTimeClock = true"
    >
      <template #append>
        <q-icon
          name="access_time"
          class="cursor-pointer"
        >
          <q-popup-proxy
            v-model="showStartTimeClock"
            transition-show="scale"
            transition-hide="scale"
          >
            <q-time
              v-model="conditional.conditionsRequirements[timeOfDayStartField]"
            >
              <div class="row items-center justify-end">
                <q-btn
                  v-close-popup
                  label="Close"
                  color="primary"
                  flat
                />
              </div>
            </q-time>
          </q-popup-proxy>
        </q-icon>
      </template>
    </model-form-input>
    <model-form-input
      :field="`conditionsRequirements.${timeOfDayEndField}`"
      class="col-4"
      :label="$_.startCase(timeOfDayEndField)"
      value-type="String"
      clearable
      :rules="[
        val => !conditional.conditionsRequirements[timeOfDayStartField] || !conditional.conditionsRequirements[timeOfDayEndField] || conditional.conditionsRequirements[timeOfDayStartField] <= conditional.conditionsRequirements[timeOfDayEndField] || 'Time cannot start after end time',
      ]"
      @clear="conditional.conditionsRequirements[timeOfDayEndField] = null"
      @click="showEndTimeClock = true"
    >
      <template #append>
        <q-icon
          name="access_time"
          class="cursor-pointer"
        >
          <q-popup-proxy
            v-model="showEndTimeClock"
            transition-show="scale"
            transition-hide="scale"
          >
            <q-time
              v-model="conditional.conditionsRequirements[timeOfDayEndField]"
            >
              <div class="row items-center justify-end">
                <q-btn
                  v-close-popup
                  label="Close"
                  color="primary"
                  flat
                />
              </div>
            </q-time>
          </q-popup-proxy>
        </q-icon>
      </template>
    </model-form-input>
    <model-form-toggle
      :field="`conditionsRequirements.${excludeTimeOfDayField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'ConditionForm',
  props: {
    conditional: {
      type: Object,
      required: true
    },
    timeOfDayStartField: {
      type: String,
      default: CONDITION_REQUIREMENTS.TIME_OF_DAY_START
    },
    timeOfDayEndField: {
      type: String,
      default: CONDITION_REQUIREMENTS.TIME_OF_DAY_END
    },
    excludeTimeOfDayField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_TIME_OF_DAY
    }
  },
  data () {
    return {
      showStartTimeClock: false,
      showEndTimeClock: false
    }
  }
}

</script>
